/* Announcement Bar */
window.addEventListener('pageshow', () => {
let announcementBar =  document.querySelector("body.homepage .announcement-bar-section");
let announcementBarAbout =  document.querySelector("body.about-page .announcement-bar-section");
if (announcementBar) {
  let announcementBarHeight = announcementBar.offsetHeight + "px";
  document.documentElement.style.setProperty('--announcement-height', `${announcementBarHeight}`);
    window.addEventListener('resize', function() {
let announcementBarHeight = announcementBar.offsetHeight + "px";
  document.documentElement.style.setProperty('--announcement-height', `${announcementBarHeight}`);
  });
}

if (announcementBarAbout) {
  let announcementBarHeight = announcementBarAbout.offsetHeight + "px";
  document.documentElement.style.setProperty('--announcement-height', `${announcementBarHeight}`);
    window.addEventListener('resize', function() {
let announcementBarHeight = announcementBarAbout.offsetHeight + "px";
  document.documentElement.style.setProperty('--announcement-height', `${announcementBarHeight}`);
  });
}
});


const isDevice = isTouchDevice();

function setViewportHeightVariable() {
  let vh = document.documentElement.clientHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

function setViewportWidthVariable() {
  let vw = document.documentElement.clientWidth * 0.01;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}

function handleSetGlobalVariables() {
  setViewportHeightVariable();
  setViewportWidthVariable();
  window.addEventListener('resize', function() {
    setViewportWidthVariable();
    if (!isDevice) {
      setViewportHeightVariable();
    }
  });

   window.addEventListener('orientationchange', function() {
    setViewportHeightVariable();
    setViewportWidthVariable();
  });
}

function isTouchDevice() {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

handleSetGlobalVariables();

/* Fade-In */
let fadeInDelay = 2500;
if (sessionStorage.getItem('session-fade')) {
fadeInDelay = 50;
  document.body.classList.add("existing-session-body");
} else {
  sessionStorage.setItem('session-fade', 'true');
}
document.addEventListener('DOMContentLoaded', () => {
  const fadeInBanner = document.querySelector('.homepage .header-wrapper');
  const fadeInBannerText = document.querySelector('.homepage .multiuse-banner-section .banner__heading');
  const fadeInBannerPreText = document.querySelector('.homepage .multiuse-banner-section .banner__preheading');
  if (fadeInBanner){
    setTimeout(() => {
      fadeInBanner.classList.add('faded', 'loaded');
      fadeInBannerText.classList.add('faded');
      fadeInBannerPreText.classList.add('faded');
    }, fadeInDelay);
  }
});

/* Newsletter Popup from AD */
const productAdTrigger = document.querySelector('.product-generic-card-wrapper');
const newsletterPopupModal = document.querySelector('newsletter-modal');
if (productAdTrigger){
  productAdTrigger.addEventListener('click', function() {
    newsletterPopupModal.setAttribute('open', '');
  });
}

const announcementBarAdd = document.querySelector(".announcement-bar__message a");
if (announcementBarAdd) {
  announcementBarAdd.addEventListener('click', function() {
    newsletterPopupModal.setAttribute('open', '');
  });
}

/* Double Sign Up */
var live_url = window.location.href;
var result = live_url.includes('form_type=customer');
var footer_val = document.querySelector("#ContactFooter input[name='contact[email]']");
var input_val = document.querySelector('#NewsletterForm--Password');
var banner_val = document.querySelector("#newsletter-banner-newsletter-banner input[name='contact[email]']");
var modal_val = document.querySelector("#NewsletterForm--Modal");

if(result && input_val != null){
  const add_ele = document.createElement("h3");
  add_ele.innerText = "You have already subscribed!";
  add_ele.classList.add('newsletter_already_subscribe','newsletter-form__message','form__message');
  document.querySelector('#contact_form_password .newsletter-form__field-wrapper').prepend(add_ele);
}

if(result && footer_val != null){
const add_ele = document.createElement("h3");
  add_ele.innerText = "You have already subscribed!";
  add_ele.classList.add('newsletter_already_subscribe','newsletter-form__message','form__message');
  document.querySelector('#ContactFooter .newsletter-form__field-wrapper').prepend(add_ele);
}

if(result && banner_val != null){
  const add_ele = document.createElement("h3");
  add_ele.innerText = "You have already subscribed!";
  add_ele.classList.add('newsletter_already_subscribe','newsletter-form__message','form__message');
  document.querySelector('#newsletter-banner-newsletter-banner .newsletter-form__field-wrapper').prepend(add_ele);
}

if(result && modal_val != null){
  const add_ele = document.createElement("h3");
  add_ele.innerText = "You have already subscribed!";
  add_ele.classList.add('newsletter_already_subscribe','newsletter-form__message','form__message');
  document.querySelector('#PopupModal-Newsletter .newsletter-form__field-wrapper').prepend(add_ele);
}

/* Homepage newsletter legal */
let homepageNewsletterInput = document.querySelector("body.homepage .multiuse-banner-section + .section + .newsletter-banner-section .newsletter-banner__default  input[name='contact[email]'");
if (homepageNewsletterInput) {
  let legalMessage = document.querySelector("body.homepage .multiuse-banner-section + .section + .newsletter-banner-section  .newsletter-default-form + .newsletter-banner__bottom-message p:first-child");
  homepageNewsletterInput.addEventListener("focus", function() {

    if (!legalMessage.classList.contains("show")) {
      legalMessage.classList.add("show")
    }
  });

  homepageNewsletterInput.addEventListener("blur", function() {
    if (legalMessage.classList.contains("show")) {
      legalMessage.classList.remove("show")
    }
  });
}




/* Cart Drawer Height */ 
let announcementBarAnyPage = document.querySelector(".announcement-bar-section");
if (announcementBarAnyPage) {
  document.body.classList.add("has-announcements");
  
}
/* Data Sale Opt Out Form */

document.addEventListener('DOMContentLoaded', () => {
  const formContainer = document.querySelector('#app-embed');

  const observer = new MutationObserver((mutationsList, observer) => {
  const form = document.querySelector('form-embed');

if (form) {
  observer.disconnect();
  const shadow = form.shadowRoot;

  const sheet = new CSSStyleSheet();
  sheet.insertRule(`
    input, textarea {
      background: transparent!important;
      box-shadow: none!important;
      border: none!important;
      border-bottom: 1px solid var(--body-text-color)!important;
      border-radius: 0!important;
      font-family: 'GT Sectra Italic', serif !important;
      font-size: 2.1rem !important;
    }
  `);
  sheet.insertRule(`
    label {
      font-size: 2.1rem!important;
      font-family: 'GT Sectra Italic', serif!important;
      color: #78684e!important;
    }
  `);
  sheet.insertRule(`
    button {
      font-family: 'sweet-sans-pro', sans-serif !important;
      text-transform: uppercase!important;
      font-weight: 800!important;
      letter-spacing: 0.18rem!important;
      padding: 2.4rem 2.8rem !important;
      font-size: 1.2rem!important;
    }
  `);
  sheet.insertRule(`
    button:hover {
      filter: none!important;
    }
  `);

  shadow.adoptedStyleSheets.push(sheet);
  formContainer.classList.add('loaded');
}
});

observer.observe(document.body, { childList: true, subtree: true });
});
